import MyInfoItem from './infoItem.vue';

MyInfoItem.install = function(Vue){
  Vue.component('MyInfoItem', MyInfoItem);
};

export default MyInfoItem;